/// <reference path="../../Administration/User/UserGrid.ts" />

namespace SorAraBul.Administration {

    import fld = UserRow.Fields;

    @Serenity.Decorators.registerClass()
    export class CompaniesUserGrid extends UserGrid {
        protected getDialogType() { return CompaniesUserDialog; }

        constructor(container: JQuery) {
            super(container);
        }

        protected getColumns() {
            return super.getColumns().filter(x => x.field !== fld.CompanyId);
        }

        protected getButtons(): Serenity.ToolButton[] {
            return [];
        }

        protected initEntityDialog(itemType, dialog) {
            super.initEntityDialog(itemType, dialog);
            Serenity.SubDialogHelper.cascade(dialog, this.element.closest('.ui-dialog'));
        }

        protected addButtonClick() {
            this.editItem({ CustomerID: this.companyID });
        }

        protected getInitialTitle() {
            return null;
        }

        protected getGridCanLoad() {
            return super.getGridCanLoad() && !!this.companyID;
        }

        private _companyID: number;

        get companyID() {
            return this._companyID;
        }

        set companyID(value: number) {
            if (this._companyID !== value) {
                this._companyID = value;
                this.setEquality('CompanyId', value);
                this.refresh();
            }
        }
    }
}